import { FooterContainer, HeartContainer } from "./style";

function Footer() {
  return (
    <FooterContainer>
      Made with <HeartContainer>&nbsp;&hearts;&nbsp;</HeartContainer> by&nbsp;
      <a
        href="https://github.com/jayant-dhawan"
        target="_blank"
        rel="noreferrer"
      >
        Jayant Dhawan
      </a>
    </FooterContainer>
  );
}

export default Footer;
